import { trpc } from '@/trpc/client';

import type { AppFlag } from './flags.generated';

export const useFeatureFlagStatus = (key: AppFlag) => {
  const { data } = trpc.flags.evaluate.useQuery(
    {
      key,
    },
    { suspense: true }
  );

  return Boolean(data);
};
